import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { swapDeviceUrl } from "./api-url.constants";

export interface SwapDeviceParams {
  roomId: string;
  currentMonitorId: string;
  newMonitorId: string;
}

export const swapDevice = async ({
  roomId,
  currentMonitorId,
  newMonitorId,
}: SwapDeviceParams): Promise<void> => {
  const response = await typedFetch(swapDeviceUrl(roomId), {
    method: API_METHODS.PUT,
    body: JSON.stringify({ currentMonitorId, newMonitorId }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || "Error swapping device");
  }
};
